import {IGameFilterDefinition} from "../filters-definitions/game-filter-definition.interface";
import {BaccaratFilterDefinition} from "../filters-definitions/game-group/baccarat.filter-definition";
import {BlackjackFilterDefinition} from "../filters-definitions/game-group/blackjack.filter-definition";
import {CrapsFilterDefinition} from "../filters-definitions/game-group/craps.filter-definition";
import {KenoFilterDefinition} from "../filters-definitions/game-group/keno.filter-definition";
import {LiveEliteLungeFilterDefinition} from "../filters-definitions/game-group/live-elite-lunge.filter-definition";
import {
    LiveEliteLoungeOrExclusiveFilterDefinition
} from "../filters-definitions/game-group/live-elite-lounge-or-exclusive.filter-definition";
import {LiveGameShowsFilterDefinition} from "../filters-definitions/game-group/live-game-shows.filter-definition";
import {PokerFilterDefinition} from "../filters-definitions/game-group/poker.filter-definition";
import {RouletteFilterDefinition} from "../filters-definitions/game-group/roulette.filter-definition";
import {ScratchcardsFilterDefinition} from "../filters-definitions/game-group/scratchcards.filter-definition";
import {SlotsFilterDefinition} from "../filters-definitions/game-group/slots.filter-definition";
import {FilterCategoryDefinitionBase} from "./filter-category-definition-base";
import {CategoryDefinitionId} from "./filter-category-definition.interface";

export class GameGroupFiltersCategoryDefinition extends FilterCategoryDefinitionBase {

    get id(): CategoryDefinitionId {
        return 'gameGroups';
    }

    get title(): string{
        return this.services.translation.translate('Game Type');
    }

    protected _loadAvailableFilters(): IGameFilterDefinition[] {
        return [
            new SlotsFilterDefinition(this.services),
            new RouletteFilterDefinition(this.services),
            new BlackjackFilterDefinition(this.services),
            new PokerFilterDefinition(this.services),
            new ScratchcardsFilterDefinition(this.services),
            new BaccaratFilterDefinition(this.services),
            new CrapsFilterDefinition(this.services),
            new KenoFilterDefinition(this.services),
            new LiveEliteLungeFilterDefinition(this.services),
            new LiveEliteLoungeOrExclusiveFilterDefinition(this.services),
            new LiveGameShowsFilterDefinition(this.services)
        ];
    }


    /*
    private _dynamicLoadFiltersDefinitions(): IGameFilterDefinition[] {
        const filtersDefinitionsModulesFactory =  require.context('../../filters-definitions/game-group/', true, /^.*\.(filter-definition)\.ts$/);
        const modulesIds = filtersDefinitionsModulesFactory.keys();
        debugger;
        return modulesIds.map(moduleId => filtersDefinitionsModulesFactory(moduleId))
            .map(module => {
                const FilterDefinitionConstructor: FilterDefinitionConstructor = module.default;
                return new FilterDefinitionConstructor(this.services);
            });
    }
    */



    /*
    readonly availableFilters: IGameFilterDefinition[] = [

        new GameGroupFilter('roulette', 'Roulette'),
        new GameGroupFilter('blackjack', 'Blackjack'),
        new GameGroupFilter('baccarat', 'Baccarat'),
            new GameGroupFilter('videoPoker', 'VideoPoker'), //!!!
        new GameGroupFilter('keno','Keno'),
        new GameGroupFilter('craps', 'Craps'),
        new GameGroupFilter('slots', ['Slot','VideoSlot']),
        new CustomFilter('poker', (game) => game.gameGroup.toLowerCase().indexOf('poker') !== -1),
        new SubgroupNameFilter('live-poker', 'poker'),
        new SubgroupNameFilter('live-blackjack', 'blackjack'),
        new SubgroupNameFilter('live-roulette', 'roulette'),
        new SubgroupNameFilter('live-baccarat', 'baccarat'),
        new SubgroupNameFilter('live-game-shows','shows'),
        new CustomFilter('live-elite-lounge', (game) => game.isEliteLounge),
        new CustomFilter('live-elite-lounge-or-exclusive', (game) => game.isEliteLounge || game.isExclusiveGame),
        new AllRouletteFilter(),
        new AllBlackjackFilter(),
        new AllBaccaratFilter(),
        new AllPokerFilter(),
        new GameGroupFilter('scratchCards', 'Scratch Card')

    ]
    */
}